// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
}

.app-preview-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin: 0;
  padding: 0;
}

.adf-viewer-content-container {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+my-libraries/+sites/document-library/shared/preview/preview.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAEF;;AACA;EACE,UAAA;AAEF","sourcesContent":[":host {\r\n  display: flex;\r\n}\r\n.app-preview-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-grow: 1;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.adf-viewer-content-container {\r\n  padding: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
